(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[478],{

/***/ 49149:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/event/forum",
      function () {
        return __webpack_require__(27002);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 41520:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ PageLayout; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60357);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(55124);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30552);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2261);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25194);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18700);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(94375);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _stores__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70959);













var PageLayout = function(param) {
    var children = param.children, _crumb = param.crumb, crumb = _crumb === void 0 ? [] : _crumb, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? "white" : _backgroundColor, _banner = param.banner, banner = _banner === void 0 ? "/image/about-banner.png" : _banner, newsPath = param.newsPath;
    var ref, ref1;
    var nav = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_stores__WEBPACK_IMPORTED_MODULE_10__/* .IndexContext */ .Z).nav;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), menu = ref2[0], setMenu = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(), active = ref3[0], setActive = ref3[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), visible = ref4[0], setVisible = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isSearch = ref5[0], setIsSearch = ref5[1];
    var navTo = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(e, item) {
        if (router.asPath == item.path) {
            return;
        }
        e.stopPropagation();
        // if (item.path === '/audience/register') {
        //   setVisible(true)
        //   return
        // }
        if (item.outlink) {
            var a = document.createElement("a");
            a.href = "".concat(item.outlink);
            a.target = "_blank";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            return;
        }
        router.push(item.path, item.path, {
            shallow: true
        });
    }, [
        active,
        nav
    ]);
    var searchNode = function(data, path) {
        for(var i = 0; i < (data === null || data === void 0 ? void 0 : data.length); i++){
            var item = data[i];
            if (item.path === path) {
                return item;
            }
            if (item.children && Array.isArray(item.children)) {
                var found = searchNode(item.children, path);
                if (found) {
                    return found;
                }
            }
        }
        return null;
    };
    // useEffect(() => {
    //   const { text } = router.query;
    //   setIsSearch(!!text)
    // }, [router.query])
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var act = searchNode(nav, newsPath || router.asPath);
        setActive(act);
        var item = nav === null || nav === void 0 ? void 0 : nav.find(function(item) {
            return item.id === (act === null || act === void 0 ? void 0 : act.parent);
        });
        setMenu(item);
    }, [
        nav
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            backgroundColor: backgroundColor
        },
        className: "jsx-ce7ef83832b5ae40" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().page) || ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "jsx-ce7ef83832b5ae40" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().pageBg) || ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: (active === null || active === void 0 ? void 0 : active.banner) || banner,
                        alt: "",
                        className: "jsx-ce7ef83832b5ae40"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "jsx-ce7ef83832b5ae40" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().pageHeader) || ""),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "jsx-ce7ef83832b5ae40",
                                children: "有机，可持续生活之美"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "jsx-ce7ef83832b5ae40",
                                children: (menu === null || menu === void 0 ? void 0 : menu.name) || (active === null || active === void 0 ? void 0 : active.name)
                            }),
                            !isSearch && (menu === null || menu === void 0 ? void 0 : menu.children) && menu.children.length > 1 && (menu.children.length == 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "jsx-ce7ef83832b5ae40",
                                children: menu === null || menu === void 0 ? void 0 : menu.children[0].name
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                className: "jsx-ce7ef83832b5ae40" + " " + (classnames__WEBPACK_IMPORTED_MODULE_5___default()([
                                    (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().pageNav)
                                ]) || ""),
                                children: menu === null || menu === void 0 ? void 0 : (ref = menu.children) === null || ref === void 0 ? void 0 : ref.map(function(item) {
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        style: {
                                            zIndex: "100",
                                            background: item.id === (active === null || active === void 0 ? void 0 : active.id) ? "#93d40b" : ""
                                        },
                                        onClick: function(e) {
                                            return navTo(e, item);
                                        },
                                        className: "jsx-ce7ef83832b5ae40",
                                        children: item.name
                                    }, item.id);
                                })
                            })),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .Swiper */ .tq, {
                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().swiper),
                                modules: [],
                                spaceBetween: 15,
                                slidesPerView: "auto",
                                style: {
                                    display: "none"
                                },
                                children: [
                                    !isSearch && (menu === null || menu === void 0 ? void 0 : menu.children) && menu.children.length > 1 && (menu.children.length == 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                        className: "jsx-ce7ef83832b5ae40",
                                        children: menu === null || menu === void 0 ? void 0 : menu.children[0].name
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "jsx-ce7ef83832b5ae40",
                                        children: menu === null || menu === void 0 ? void 0 : (ref1 = menu.children) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
                                            /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .SwiperSlide */ .o5, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    style: {
                                                        zIndex: "100",
                                                        background: item.id === (active === null || active === void 0 ? void 0 : active.id) ? "#93d40b" : ""
                                                    },
                                                    onClick: function(e) {
                                                        return navTo(e, item);
                                                    },
                                                    className: "jsx-ce7ef83832b5ae40" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().swiperList) || ""),
                                                    children: item.name
                                                })
                                            }, item.id);
                                        })
                                    })),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .SwiperSlide */ .o5, {})
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "jsx-ce7ef83832b5ae40" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().crumb) || ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "/image/crumb-icon.png",
                        alt: "",
                        className: "jsx-ce7ef83832b5ae40"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_3__/* .Breadcrumb */ .aG, {
                        compact: false,
                        routes: [
                            {
                                path: "/",
                                name: "首页"
                            },
                            {
                                path: (active === null || active === void 0 ? void 0 : active.path) || (menu === null || menu === void 0 ? void 0 : menu.path) || "",
                                name: (menu === null || menu === void 0 ? void 0 : menu.name) || "",
                                isShow: !menu
                            },
                            {
                                path: (active === null || active === void 0 ? void 0 : active.path) || "",
                                name: (active === null || active === void 0 ? void 0 : active.name) || "",
                                isShow: !active
                            }
                        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(crumb)).filter(function(item) {
                            return !item.isShow;
                        }),
                        onClick: function(item) {
                            router.push(item.path, item.path, {
                                shallow: true
                            });
                        },
                        separator: ">"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "jsx-ce7ef83832b5ae40" + " " + (classnames__WEBPACK_IMPORTED_MODULE_5___default()([
                    (_styles_module_scss__WEBPACK_IMPORTED_MODULE_11___default().content),
                    "content"
                ]) || ""),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "jsx-ce7ef83832b5ae40",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        style: {
                            width: "100%"
                        },
                        className: "jsx-ce7ef83832b5ae40",
                        children: children
                    })
                })
            }),
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                id: "ce7ef83832b5ae40",
                children: '.semi-navigation{border:none!important;padding:0!important}.semi-navigation-header-text{width:100%}.semi-navigation-header{padding:0!important;margin-top:40px}.semi-navigation-item{height:auto!important;padding:0 12px!important}.semi-navigation-item-text{display:block;width:100%}.semi-navigation-footer{position:absolute;top:0;left:20%}.semi-navigation-list-wrapper{height:auto!important;padding:0!important;margin:10px 0}.semi-breadcrumb-item-active{color:#094020!important}.semi-navigation-collapsed{height:70px!important}.semi-breadcrumb-item-link:hover{color:#808080}.semi-notification-notice{min-width:"200px"}.swiper-wrapper,.swiper-slide{width:auto}.semi-breadcrumb-item-wrap{margin:4px 6px}'
            })
        ]
    });
};


/***/ }),

/***/ 27002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_pagelay__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41520);
/* harmony import */ var _utils_useHead__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25838);
/* harmony import */ var _utils_useRequest__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54013);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(72126);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);









var __N_SSP = true;
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(param) {
    var navDetail = param.navDetail;
    var ref, ref1;
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}), data = ref2[0], setData = ref2[1];
    var request = (0,_utils_useRequest__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var month = {
        "01": "一",
        "02": "二",
        "03": "三",
        "04": "四",
        "05": "五",
        "06": "六",
        "07": "七",
        "08": "八",
        "09": "九",
        "10": "十",
        "11": "十一",
        "12": "十二"
    };
    var groupAndSortEvents = function(events) {
        var result = {};
        // 1. 按日期和地点分组
        events.forEach(function(event) {
            var date = event.date_start_en.substring(0, 10); // 提取日期部分
            var location = event.location_en;
            if (!result[date]) {
                result[date] = {};
            }
            if (!result[date][location]) {
                result[date][location] = [];
            }
            result[date][location].push(event);
        });
        // 2. 对每组内按时间排序
        for(var date in result){
            for(var location in result[date]){
                result[date][location].sort(function(a, b) {
                    return a.date_start_en.localeCompare(b.date_start_en);
                });
            }
        }
        return result;
    };
    var getData = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function() {
        var ref, ref1, data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        request.get("/home/get_event_list", {
                            params: {
                                category_id: 3,
                                rows: 999
                            }
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    setData(groupAndSortEvents(((ref = data.data) === null || ref === void 0 ? void 0 : ref.list) || []));
                    console.log(groupAndSortEvents(((ref1 = data.data) === null || ref1 === void 0 ? void 0 : ref1.list) || []));
                    return [
                        2
                    ];
            }
        });
    }), []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        getData();
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pagelay__WEBPACK_IMPORTED_MODULE_2__/* .PageLayout */ .X, {
        banner: "/image/event-banner.png",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().container),
            children: [
                (0,_utils_useHead__WEBPACK_IMPORTED_MODULE_3__/* .getHead */ .c)(navDetail),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    children: "会议论坛"
                }),
                (ref1 = (ref = Object.keys(data)) === null || ref === void 0 ? void 0 : ref.reverse()) === null || ref1 === void 0 ? void 0 : ref1.map(function(item) {
                    var ref, ref1, ref2;
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: "时间"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().line),
                                        children: "/"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                style: {
                                                    color: "#1447c1"
                                                },
                                                children: month[(ref = item === null || item === void 0 ? void 0 : item.split("-")) === null || ref === void 0 ? void 0 : ref[1]]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                style: {
                                                    color: "#14c7b8"
                                                },
                                                children: "月"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                style: {
                                                    color: "#01c773"
                                                },
                                                children: (ref1 = item === null || item === void 0 ? void 0 : item.split("-")) === null || ref1 === void 0 ? void 0 : ref1[2]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            (ref2 = Object.keys(data[item])) === null || ref2 === void 0 ? void 0 : ref2.reverse().map(function(child) {
                                var ref;
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "itemBox",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                            children: child
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                            children: (ref = data[item][child]) === null || ref === void 0 ? void 0 : ref.map(function(event) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                        href: "/event/forum/detail?id=".concat(event.id),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_8___default().time),
                                                                children: [
                                                                    event.date_start_en.slice(11, 16),
                                                                    "-",
                                                                    event.date_end_en.slice(11, 16)
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                children: event.title_en
                                                            })
                                                        ]
                                                    })
                                                }, event.id);
                                            })
                                        })
                                    ]
                                }, child);
                            })
                        ]
                    }, item);
                })
            ]
        })
    });
};


/***/ }),

/***/ 25838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ getHead; }
/* harmony export */ });
/* unused harmony export getServerSideProps */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48847);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);








var getServerSideProps = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(context) {
        var lang, data, newData;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    lang = context.resolvedUrl.slice(0, 3) === "/en" ? "en" : "cn";
                    return [
                        4,
                        axios__WEBPACK_IMPORTED_MODULE_1___default().get("".concat(_utils__WEBPACK_IMPORTED_MODULE_5__/* .PRODDOMAIN */ .sC, "/home/menu_info"), {
                            params: {
                                pathinfo: (lang === "en" ? context.resolvedUrl.slice(3) : context.resolvedUrl) || "/"
                            }
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    newData = {};
                    if (data.code == 1) {
                        newData = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, data.data), {
                            seo_title: data.data["seo_title_".concat(lang)] || (lang === "cn" ? "2025亚洲有机产业展览会 | 有机产品与可持续发展盛会" : "Organic Festa Asia 2025 | Premier Exhibition for Organic Products and Sustainable Development"),
                            title: data.data["title_".concat(lang)],
                            content: data.data["content_".concat(lang)],
                            // brief: data.data[`brief_${lang}`],
                            seo_desc: data.data["seo_desc_".concat(lang)] || (lang === "cn" ? "亚洲有机产业展览会，有机产品展览，2025上海有机展，可持续发展，国际有机贸易平台" : "Organic Festa Asia, organic products exhibition, 2025 Shanghai organic expo, sustainable development, international organic trade platform"),
                            seo_keyword: data.data["seo_keyword_".concat(lang)] || (lang === "cn" ? "欢迎参加将于2025年9月3日至5日在上海举办的亚洲有机产业展览会。汇聚全球顶尖有机品牌、专业买家和行业专家，探索有机产品与可持续发展的最新趋势和商机。" : "Join us at the Organic Festa Asia 2025, taking place from September 3 to 5 in Shanghai. Connect with leading organic brands, professional buyers, and industry experts worldwide to explore the latest trends and opportunities in organic products and sustainable development.")
                        });
                    }
                    return [
                        2,
                        {
                            props: {
                                navDetail: newData || {}
                            }
                        }
                    ];
            }
        });
    });
    return function getServerSideProps(context) {
        return _ref.apply(this, arguments);
    };
}();
var getHead = function(navDetail) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                children: [
                    navDetail === null || navDetail === void 0 ? void 0 : navDetail.seo_title,
                    " "
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: navDetail === null || navDetail === void 0 ? void 0 : navDetail.seo_keyword
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: navDetail === null || navDetail === void 0 ? void 0 : navDetail.seo_desc
            })
        ]
    });
};



/***/ }),

/***/ 55124:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"page":"styles_page__raIZH","pageBg":"styles_pageBg__uSGYm","pageHeader":"styles_pageHeader__Kkw7J","pageNav":"styles_pageNav__UKUc2","crumb":"styles_crumb__IAstN","content":"styles_content__eWsF4","swiper":"styles_swiper__r2mXM","swiperList":"styles_swiperList__Bj6Lh"};

/***/ }),

/***/ 72126:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"forum_container__hUKaO","line":"forum_line__AgN2G","time":"forum_time__DHYgX"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [222,774,888,179], function() { return __webpack_exec__(49149); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);